import { Header, Tabs } from '@components';
import { useUserQuery } from '@features/api/userSlice';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { profileTabs } from './ProfileContainer.const';
import {
  StyledContainer,
  StyledHeaderContainer,
} from './ProfileContainer.styles';

const ProfileContainer: React.FC = () => {
  const intl = useIntl();
  const { data: user } = useUserQuery();
  const [activeTab, setActiveTab] = useState<number>(0);
  return (
    <>
      <StyledContainer>
        <StyledHeaderContainer>
          <Header
            user={user}
            title={{ name: intl.formatMessage({ id: 'menu.profile' }) }}
          />
        </StyledHeaderContainer>
        <Tabs
          variant='scrollable'
          allowScrollButtonsMobile
          tabItem={profileTabs}
          onChange={(_, value) => setActiveTab(value)}
          value={activeTab}
        />
      </StyledContainer>
    </>
  );
};

export default ProfileContainer;
